var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"model-select",attrs:{"value":_vm.modelType,"popper-append-to-body":false},on:{"change":_vm.onChangeModelSelect}},_vm._l((_vm.modelTypeList),function({ label, value }){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }